import { createContext, useContext, useState } from 'react';

import { useCustomClearRefinements } from '@javascript/lib/hooks/useCustomClearRefinements';

type InstantSearchResetContextProps = {
  clearFiltersAndLocation: VoidFunction;
  resetCount: number;
};

const InstantSearchResetContext =
  createContext<InstantSearchResetContextProps | null>(null);

export const useInstantSearchReset = () => {
  const context = useContext(InstantSearchResetContext);

  if (!context) {
    throw new Error(
      'useInstantSearchReset must be used within an InstantSearchResetProvider',
    );
  }

  return context;
};

const InstantSearchResetProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { clearFiltersAndLocation: clearRefinementsAndLocation } =
    useCustomClearRefinements();
  const [resetCount, setResetCount] = useState(0);

  const clearFiltersAndLocation = () => {
    clearRefinementsAndLocation();
    setResetCount((count) => count + 1);
  };

  return (
    <InstantSearchResetContext.Provider
      value={{ clearFiltersAndLocation, resetCount }}
    >
      {children}
    </InstantSearchResetContext.Provider>
  );
};

export default InstantSearchResetProvider;
